<div class="table-list--mobile" *ngIf="loaded; else loading">
    <ng-content></ng-content>

    <div class="table-list__empty" *ngIf="photos && photos.length < 1">
        <p>De map is leeg, omdat deze informatie voor uw claim niet nodig is.</p>
    </div>
</div>

<ng-template #loading>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
</ng-template>
